import React from 'react';
import {
    CallTakerStationContext,
    CallTakerStationContextValue,
} from './call-taker-station-context';

export function useCallTakerStation(): CallTakerStationContextValue {
    const stationContextValue = React.useContext(CallTakerStationContext);
    if (!stationContextValue) {
        throw new Error('Unexpectedly could not find station context value.');
    }
    return stationContextValue;
}
